import React from 'react';
import PropTypes from 'prop-types';
import ErrorHint from './ErrorHint';

export const CURRENCY = {
  RUB: 'RUB',
  EUR: 'EUR',
  USD: 'USD',
  COUNT: ''
};

export const FIXED = {
  RUB: 2,
  EUR: 2,
  USD: 2,
  COUNT: 0
};

export const CURRENCY_SYMBOL = {
  RUB: String.fromCharCode(8381),
  EUR: String.fromCharCode(8364),
  USD: String.fromCharCode(36),
  COUNT: ''
};

const getFixedPrice = (price, fix) => {
  let fixedPrice = Number(price.toFixed(fix));
  return Math.abs(fixedPrice - ~~fixedPrice) > 0 ? fixedPrice : ~~fixedPrice;
};

const getNumber = (price, defaultValue = '') => {
  let amount = defaultValue;

  if (typeof price === 'number') {
    amount = price;
  } else if (typeof price === 'string') {
    amount = Number(price);
    if (isNaN(amount)) {
      amount = defaultValue;
    }
  }

  return amount;
};

const Price = ({ value = 0, currency = CURRENCY.RUB, className = '', delim = ' ', onClick }) => {
  const symbol = CURRENCY_SYMBOL[currency.toUpperCase()] || '';

  const numberWithSpaces = () => {
    let parts = (typeof value === 'number' ? getFixedPrice(value, FIXED[currency]) : 0 ).toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, delim);
    return parts.join(".");
  }

  return (
    <span className={`currency ${className}`} onClick={onClick}>{numberWithSpaces()}{symbol}</span>
  );
};

Price.propTypes = {
  className: PropTypes.string,
  delim: PropTypes.string,
  value: PropTypes.number,
  currency: PropTypes.string,
  onClick: PropTypes.func
};


class Input2 extends React.Component {
  constructor(props) {
    super(props);
    this.onInput = typeof props.onInput === 'function' ? props.onInput : () => {};
    this.onChange = typeof props.onChange === 'function' ? props.onChange : () => {};

    this.state = {
      val: getNumber(props.value),
      currency: props.currency || CURRENCY.RUB
    };
  }

  componentDidUpdate(prevProps) {
    if (getNumber(this.props.value) !== this.state.val) {
      this.setState({ ...prevProps, val: getNumber(this.props.value) });
    }
  }

  inputValue(value, target) {
    this.setState((prevProps) => ({ ...prevProps, val: value }));
    this.onInput(value, target);
  };

  changeValue(value, target) {
    this.setState((prevProps) => ({ ...prevProps, val: value }));
    this.onChange(value, target);
  };

  render() {
    return (
      <>
        <div className="input-field input-group">
          {this.props.note && (
            <span className='input-note'>{this.props.note}</span>
          )}
          <input type="number" className={`form-control ${this.props.className || ''}`} min={this.props.min} max={this.props.max} placeholder={this.props.placeholder}
            onInput={(e) => this.inputValue(getNumber(e.target.value), e.target)}
            onChange={(e) => this.changeValue(getNumber(e.target.value), e.target)}
            value={this.state.val}
          />
          <span className="input-group-text">{CURRENCY_SYMBOL[this.state.currency.toUpperCase()]}</span>
        </div>

        {this.props.error && (
          <ErrorHint error={this.props.error} />
        )}
      </>
    );
  }
}

Input2.propTypes = {
  className: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  note: PropTypes.string,
  error: PropTypes.string,
  onInput: PropTypes.func,
  onChange: PropTypes.func,
  currency: PropTypes.string,
  placeholder: PropTypes.any,
};

Price.Input2 = Input2;


const Input = ({ className = '', currency = CURRENCY.RUB, min, max, value, note, noteAction, error, placeholder, onInput, onChange }) => {
  return (
    <>
      <div className="input-field input-group">
        {note && (
          <span className='input-note' onClick={noteAction}>{note}</span>
        )}
        <input type="number" className={`form-control ${className}`} min={min} max={max} placeholder={placeholder} onInput={(e) => onInput && onInput(getNumber(e.target.value))} onChange={(e) => onChange && onChange(getNumber(e.target.value))} defaultValue={value} />
        <span className="input-group-text">{CURRENCY_SYMBOL[currency.toUpperCase()]}</span>
      </div>

      {error && (
        <ErrorHint error={error} />
      )}
    </>
  );
};

Input.propTypes = {
  className: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  note: PropTypes.string,
  noteAction: PropTypes.func,
  error: PropTypes.string,
  onInput: PropTypes.func,
  onChange: PropTypes.func,
  currency: PropTypes.string,
  placeholder: PropTypes.any,
};

Price.Input = Input;

const Text = ({ value = 0, currency = CURRENCY.RUB, delim = ' ' }) => {
  const symbol = CURRENCY_SYMBOL[currency.toUpperCase()] || '';

  const numberWithSpaces = () => {
    if (typeof value === 'string') {
      value = Number(value);
    }
    let parts = (typeof value === 'number' ? getFixedPrice(value, FIXED[currency]) : 0 ).toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, delim);
    return parts.join(".");
  }

  return `${numberWithSpaces()}${symbol}`;
};

Text.propTypes = {
  delim: PropTypes.string,
  value: PropTypes.number.isRequired,
  currency: PropTypes.string
};

Price.Text = Text

export default Price;